import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=44c6d720&scoped=true&"
import script from "./OrdersSummary.vue?vue&type=script&lang=js&"
export * from "./OrdersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6d720",
  null
  
)

export default component.exports